import SpinnerSvg from "@/assets/svg/spinner.svg?react";
import { cn } from "@core/utils/domUtil";

export default function Spinner({ className }: { className?: string }) {
  // return (
  //   <div className="h-16 w-16 origin-center animate-spin [&_svg]:size-full">
  //     <SpinnerSvg />
  //   </div>
  // );

  // return <div className="h-6 w-6 animate-spin rounded-full border-4 border-gray-200 border-t-blue-500" />;

  return (
    <div className={cn("flex space-x-2", className)}>
      <div className="bg-point-50 h-3 w-3 animate-bounce rounded-full [animation-delay:0ms]" />
      <div className="bg-point-200 h-3 w-3 animate-bounce rounded-full [animation-delay:150ms]" />
      <div className="bg-point-600 h-3 w-3 animate-bounce rounded-full [animation-delay:300ms]" />
    </div>
  );

  // return <div className="h-10 w-10 animate-spin rounded-full border-4 border-white border-t-transparent" />;
}
